/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import ClassNames from "classnames";
import dayjs from "dayjs";
import Popover from "@material-ui/core/Popover";
import CloseIcon from "@material-ui/icons/Close";

import styles from "./index.module.scss";

import {
  COACH_URL,
  Framework,
  Method,
  PD_COACH_URL,
  StatusMapping,
} from "../../config/Config";
import { apiRequest } from "../../utils/api";
import { useNotification } from "../../context/notification";
import { getLocalValue } from "../../utils/auth";
import { dayJS, utcToLocal, localToUTC } from "../../utils/datetime";
import GetSessionData from "../../services/getSessionData";
import Button from "../Button";

import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ScheduleIcon from "@material-ui/icons/Schedule";
import { useTranslation } from "react-i18next";

export default function Calendar({ userId, ...props }) {
  const { addNotification } = useNotification();
  const { t } = useTranslation();
  const history = useHistory();
  const [calendarData, setCalendarData] = useState({});
  const [pendingCalendarData, setPendingCalendarData] = useState([]);
  const [upcomingCalendarData, setUpcomingCalendarData] = useState([]);
  const [popoverData, setPopoverData] = useState({});
  const [popoverPendingTask, setPopoverPendingTask] = useState({});
  const [popoverDate, setPopoverDate] = useState(null);
  const [showMore, setShowMore] = useState(false);
  const [isUpcomingPopover, setIsUpcomingPopover] = useState(false);
  const [popoverSessionId, setPopoverSessionId] = useState(null);
  const [popoverTitle, setPopoverTitle] = useState(null);
  const [response, setResponse] = useState({});
  const [sessionData, setSessionData] = useState({});
  const [subjectList, setSubjectList] = useState([]);
  const [sessionUrl, setSessionUrl] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);

  const coach_id = userId ? userId : getLocalValue("uid");
  const startDate = localToUTC(new Date())
    .hour(0)
    .minute(0)
    .second(0)
    .format("YYYY-MM-DD HH:mm:ss");
  const endDate = localToUTC(new Date())
    .hour(23)
    .minute(59)
    .second(59)
    .add(6, "day")
    .format("YYYY-MM-DD HH:mm:ss");

  useEffect(() => {
    // get Team Dashboard Calendar details
    apiRequest
      .get(
        `/api/getTeamDashboardCalendar?coach_id=${coach_id}&start_datetime=${startDate}&end_datetime=${endDate}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          if (!_.isEmpty(data)) {
            setCalendarData(response.data.data);
            setPendingCalendarData(data.pendingSessionDetails);
          }
          if (!_.isEmpty(data) && data.upcomingSessionDetails.length > 0) {
            let filteredData = [];
            [...Array(7)].map((e, i) => {
              const date = getDate(i, "YYYY-MM-DD");
              filteredData = {
                ...filteredData,
                [date]: [...data.upcomingSessionDetails].filter(
                  upcomnigData =>
                    date ===
                    utcToLocal(upcomnigData.datetime).format("YYYY-MM-DD")
                ),
              };
            });
            setUpcomingCalendarData(filteredData);
          }
        }
      })
      .catch(error => {});
  }, []);

  useEffect(() => {
    setShowMore(
      pendingCalendarData.length > 2 ||
        (upcomingCalendarData[getDate(0, "YYYY-MM-DD")] &&
          upcomingCalendarData[getDate(0, "YYYY-MM-DD")].length > 2)
    );
  }, [upcomingCalendarData, pendingCalendarData]);

  useEffect(() => {
    if (popoverSessionId) {
      getSessionDetails();
    }
  }, [popoverSessionId]);

  useEffect(() => {
    if (response.subject && response.subject.length > 0) {
      setSubjectList(response.subject);
    }
    setSessionData(response.session);
  }, [response]);

  async function getSessionDetails() {
    const sessionAPIData = await GetSessionData(popoverSessionId);
    if (sessionAPIData) {
      setResponse(sessionAPIData);
    } else {
      addNotification(`Could not get session ${id}`, "error");
    }
  }

  const handleClick = (
    event,
    task,
    date,
    pendingCalendarData,
    upcomingTask
  ) => {
    setAnchorEl(event.target.parentElement);
    setPopoverData(task);
    setPopoverDate(date);
    setPopoverPendingTask(pendingCalendarData ? pendingCalendarData : []);
    setIsUpcomingPopover(upcomingTask);
  };
  const handleUpcomingPopover = (
    event,
    title,
    sessionId,
    url,
    innerPopup = false
  ) => {
    setAnchorEl(innerPopup ? anchorEl : event.target.parentElement);
    setPopoverSessionId(sessionId);
    setPopoverTitle(title);
    setIsUpcomingPopover(true);
    setSessionUrl(url);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsUpcomingPopover(false);
  };

  // helper function to get values under "session" in data object
  const getSessionValue = field => {
    return sessionData ? sessionData[field] : undefined;
  };

  const getDate = (index, format) => {
    return dayJS(new Date()).add(index, "day").format(format);
  };

  const open = Boolean(anchorEl);
  const id = open ? "calendar-task" : undefined;

  const getTranslated = string => {
    let currentString = string;
    const regex = /\bt\("([A-Za-z0-9-:.]*)\b"\)/g;
    let translationCode = currentString.match(regex);
    if (translationCode && translationCode.length > 0) {
      translationCode.forEach(string => {
        currentString = currentString.replace(string, eval(string));
      });
    }
    console.log("test", eval(translationCode[0]));
    return currentString;
  };

  return (
    <div className={styles.CalendarWrapper}>
      <div className={styles.column} aria-describedby={id}>
        <div className={styles.date}>{getDate(0, "DD MMM, YYYY")}</div>

        {/* Show first two pending data */}
        {pendingCalendarData.length > 0 &&
          pendingCalendarData.slice(0, 2).map((pendingData, index) => (
            <div key={index} className={styles.pendingTask}>
              <Link
                to={`${COACH_URL[pendingData.status]}${pendingData.session_id}`}
              >
                {" "}
                <span
                  dangerouslySetInnerHTML={{
                    __html: getTranslated(pendingData.message),
                  }}
                ></span>
              </Link>
            </div>
          ))}

        {/* Show upcoming task if pending data length is less than 2 */}
        {pendingCalendarData.length < 2 &&
          upcomingCalendarData[getDate(0, "YYYY-MM-DD")] &&
          upcomingCalendarData[getDate(0, "YYYY-MM-DD")]
            .slice(0, 2)
            .map((upcomingData, index) => (
              <div key={index} className={styles.upcomingTask}>
                <Link
                  to={`${COACH_URL[upcomingData.status]}${
                    upcomingData.session_id
                  }`}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: getTranslated(upcomingData.message),
                    }}
                  ></span>
                </Link>
              </div>
            ))}

        {/* Show more button if pending task or upcoming task length more than 2 */}
        {showMore && (
          <span
            className={styles.upcomingTask}
            style={{ cursor: "pointer" }}
            onClick={event => {
              handleClick(
                event,
                upcomingCalendarData[getDate(0, "YYYY-MM-DD")],
                dayJS(new Date()).add(0, "day"),
                pendingCalendarData
              );
            }}
          >
            +
            {pendingCalendarData.length +
              (upcomingCalendarData[getDate(0, "YYYY-MM-DD")]
                ? upcomingCalendarData[getDate(0, "YYYY-MM-DD")].length
                : 0) -
              2}{" "}
            more
          </span>
        )}
      </div>

      {[...Array(6)].map((e, i) => (
        <div className={styles.column} key={i} aria-describedby={id}>
          <div className={styles.date}>{getDate(i + 1, "DD MMM, YYYY")}</div>

          {upcomingCalendarData[getDate(i + 1, "YYYY-MM-DD")] &&
            upcomingCalendarData[getDate(i + 1, "YYYY-MM-DD")]
              .slice(0, 2)
              .map((upcomingData, index) => (
                <div key={index} className={styles.upcomingTask}>
                  <span
                    onClick={event => {
                      const URL =
                        upcomingData.framework === Framework.PD
                          ? `${PD_COACH_URL[upcomingData.status]}${
                              upcomingData.session_id
                            }`
                          : `${COACH_URL[upcomingData.status]}${
                              upcomingData.session_id
                            }`;
                      handleUpcomingPopover(
                        event,
                        getTranslated(upcomingData.message),
                        upcomingData.session_id,
                        URL
                      );
                    }}
                    dangerouslySetInnerHTML={{
                      __html: getTranslated(upcomingData.message),
                    }}
                  ></span>
                </div>
              ))}

          {upcomingCalendarData[getDate(i + 1, "YYYY-MM-DD")] &&
            upcomingCalendarData[getDate(i + 1, "YYYY-MM-DD")].length > 2 && (
              <span
                className={styles.upcomingTask}
                style={{ cursor: "pointer" }}
                onClick={event => {
                  handleClick(
                    event,
                    upcomingCalendarData[getDate(i + 1, "YYYY-MM-DD")],
                    dayJS(new Date()).add(i + 1, "day")
                  );
                }}
              >
                +{upcomingCalendarData[getDate(i + 1, "YYYY-MM-DD")].length - 2}{" "}
                more
              </span>
            )}
        </div>
      ))}

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div
          className={`${styles.popover} ${
            isUpcomingPopover && styles.upcomingPopover
          }`}
        >
          <span className={styles.popoverClose} onClick={handleClose}>
            <CloseIcon style={{ fontSize: 18, color: "#333333" }} />
          </span>
          {!isUpcomingPopover && (
            <>
              {!_.isEmpty(popoverDate) && (
                <div className={styles.popoverDate}>
                  <span className={styles.day}>
                    {popoverDate.format("ddd")}
                  </span>
                  <span>{popoverDate.format("DD")}</span>
                </div>
              )}

              {popoverPendingTask.length > 0 &&
                popoverPendingTask.map((pendingData, index) => (
                  <div key={index} className={styles.pendingTask}>
                    <Link
                      to={`${COACH_URL[pendingData.status]}${
                        pendingData.session_id
                      }`}
                    >
                      {" "}
                      <span
                        dangerouslySetInnerHTML={{
                          __html: getTranslated(pendingData.message),
                        }}
                      ></span>
                    </Link>
                  </div>
                ))}

              {!_.isEmpty(popoverData) &&
                popoverData.map((task, index) => (
                  <div key={index} className={styles.task}>
                    <span
                      onClick={event => {
                        const URL =
                          task.status === Framework.PD
                            ? `${PD_COACH_URL[task.status]}${task.session_id}`
                            : `${COACH_URL[task.status]}${task.session_id}`;
                        handleUpcomingPopover(
                          event,
                          task.message,
                          task.session_id,
                          URL,
                          true
                        );
                      }}
                      dangerouslySetInnerHTML={{
                        __html: getTranslated(task.message),
                      }}
                    ></span>
                  </div>
                ))}
            </>
          )}

          {isUpcomingPopover && (
            <>
              {!_.isEmpty(popoverTitle) && (
                <div
                  className={styles.popoverTitle}
                  dangerouslySetInnerHTML={{ __html: popoverTitle }}
                ></div>
              )}
              <div className={styles.row}>
                <div className={styles.rowLeft}>Coaching date</div>
                <div className={styles.rowRight}>
                  <span className={styles.rowIcon}>
                    <CalendarTodayIcon />
                  </span>
                  <span style={{ padding: "0 12px 0 4px" }}>
                    {/* Time format: 9 Jan 2020 */}
                    {dayjs(getSessionValue("session_datetime"))
                      .add(dayjs().utcOffset(), "minutes")
                      .format("D MMM YYYY")}
                  </span>
                  <span className={styles.rowIcon}>
                    <ScheduleIcon />
                  </span>
                  <span style={{ padding: "0 12px 0 4px" }}>
                    {/* Time format: 8:12 PM*/}
                    {dayjs(getSessionValue("session_datetime"))
                      .add(dayjs().utcOffset(), "minutes")
                      .format("h:mm A")}
                  </span>
                </div>
              </div>

              {
                //If PD Review Date will not show
                getSessionValue("framework") === Framework.PDCA && (
                  <div className={styles.row}>
                    <div className={styles.rowLeft}>Review date</div>
                    <div className={styles.rowRight}>
                      <span className={styles.rowIcon}>
                        <CalendarTodayIcon />
                      </span>
                      <span style={{ padding: "0 12px 0 4px" }}>
                        {/* Time format: 9 Jan 2020 */}
                        {dayjs(getSessionValue("review_datetime"))
                          .add(dayjs().utcOffset(), "minutes")
                          .format("D MMM YYYY")}
                      </span>
                      <span className={styles.rowIcon}>
                        <ScheduleIcon />
                      </span>
                      <span style={{ padding: "0 12px 0 4px" }}>
                        {/* Time format: 8:12 PM*/}
                        {dayjs(getSessionValue("review_datetime"))
                          .add(dayjs().utcOffset(), "minutes")
                          .format("h:mm A")}
                      </span>
                    </div>
                  </div>
                )
              }
              <div className={styles.row}>
                <div className={styles.rowLeft}>Method</div>
                <div className={styles.rowRight}>
                  {Method[getSessionValue("method")]}
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.rowLeft}>Type of sessions</div>
                <div className={styles.rowRight}>
                  {getSessionValue("session_type")}
                </div>
              </div>
              <div className={ClassNames(styles.row)}>
                <div className={ClassNames(styles.rowLeft)}>Subjects</div>
                <div className={ClassNames(styles.rowRight)}>
                  {subjectList.map(item => (
                    <div
                      className={styles.subjectName}
                      key={getSessionValue("session_id")}
                      title={item.subject}
                    >
                      {item.subject}
                      {item.sub_subject ? " — " + item.sub_subject : ""}
                    </div>
                  ))}
                </div>
              </div>
              <div className={ClassNames(styles.row)}>
                <div className={ClassNames(styles.rowLeft)}>Status</div>
                <div className={ClassNames(styles.rowRight)}>
                  <span className={styles.status}>
                    {StatusMapping[getSessionValue("status")]}
                  </span>
                </div>
              </div>
              <div className={ClassNames(styles.row)}>
                <div className={styles.footnote}>
                  You can only start the review session once you have completed
                  all the previous stages.
                </div>
              </div>
              <div className={ClassNames(styles.row, styles.noPaddingBottom)}>
                <Button
                  variant="outlined"
                  color="primary"
                  style={{ width: "100%" }}
                  onClick={() => history.push(sessionUrl)}
                >
                  Go to the latest stage
                </Button>
              </div>
            </>
          )}
        </div>
      </Popover>
    </div>
  );
}
